import styled from 'styled-components';

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: clamp(24px, 5vw, 40px);
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;

  @media (max-width: 480px) {
    border-radius: 12px;
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.gray[900]};
  margin-bottom: 16px;
  text-align: center;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 24px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray[900]};
`;

export const Input = styled.input`
  width: 100%;
  height: 52px;
  padding: 0 16px;
  background: #fff;
  border: 2px solid ${({ theme, $hasError }) => 
    $hasError ? theme.colors.danger.main : theme.colors.gray[100]};
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.2s ease-in;
  outline: none;

  &:focus {
    border-color: ${({ theme, $hasError }) => 
      $hasError ? theme.colors.danger.main : theme.colors.primary.main};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray[200]};
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 52px;
  background: ${({ theme, variant }) => 
    variant === 'outline' ? 'transparent' : theme.colors.primary.main};
  color: ${({ theme, variant }) => 
    variant === 'outline' ? theme.colors.primary.main : '#fff'};
  border: ${({ theme, variant }) => 
    variant === 'outline' ? `2px solid ${theme.colors.primary.main}` : 'none'};
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in;

  &:hover:not(:disabled) {
    background: ${({ theme, variant }) => 
      variant === 'outline' ? theme.colors.primary.main : theme.colors.primary.light};
    color: #fff;
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.gray[100]};
    color: ${({ theme }) => theme.colors.gray[200]};
    cursor: not-allowed;
    border: none;
  }
`;

export const InfoText = styled.p`
  font-size: 14px;
  color: ${({ theme, $error }) => $error ? theme.colors.danger.main : theme.colors.gray[600]};
  text-align: center;
  line-height: 1.6;
  margin-bottom: 8px;
`;

export const Message = styled.p`
  font-size: 16px;
  color: ${({ theme, $error }) => $error ? theme.colors.danger.main : theme.colors.gray[900]};
  text-align: center;
  line-height: 1.6;
  margin-bottom: 24px;
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.danger.main};
  margin-top: -4px;
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const TogglePasswordButton = styled.button`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.gray[400]};
  transition: color 0.2s ease-in;

  &:hover {
    color: ${({ theme }) => theme.colors.gray[600]};
  }

  &:focus {
    outline: none;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
